const ALL_PROJECT_ASSETS_PAGE = 1
const ALL_PROJECT_ASSETS_PER_PAGE = 1000

export const listAllProjectAssetsParams = {
	page: ALL_PROJECT_ASSETS_PAGE,
	per_page: ALL_PROJECT_ASSETS_PER_PAGE,
} as const
